import { useMutation } from "@tanstack/react-query";
import api from "../../api";
import { createError, HTTPErrors } from "../../errors";

type Props = {
  sectionId: string;
};
type Params = {
  studentId: string;
  originLectureSessionId: string;
  destinationLectureSessionId: string;
};

type MutationResult = {
  lectureAttendance: {
    originLectureSessionId: string;
  };
};
export const useMutateLectureTransfer = ({ sectionId }: Props) => {
  return useMutation<MutationResult, HTTPErrors, Params>({
    mutationFn: async ({
      studentId,
      originLectureSessionId,
      destinationLectureSessionId,
    }: Params) => {
      const response = await api.post(
        `/api/v1/sections/${sectionId}/lecture_sessions/${originLectureSessionId}/students/${studentId}/lecture_transfers`,
        {
          transfer_lecture_session_id: destinationLectureSessionId,
        },
      );
      if (response.ok) {
        return await response.json();
      }
      throw await createError(response);
    },
  });
};
